import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { useSectors, useSiteImages } from "../content/useContent";
import { IconByName } from "../components/IconByName";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { FinalCTA } from "../components/FinalCTA";
import { ArrowRight } from "lucide-react";

const Sectors = () => {
  const { lang, t, p } = useLang();
  const sectors = useSectors();
  const IMG = useSiteImages();
  return (
    <div data-testid="sectors-page">
      <Seo title={t.nav.sectors} path="secteurs" />
      <PageHero eyebrow="BULA TELECOMS SA" title={t.segments.heading} image={IMG.teamCouch} crumbs={[{ label: t.nav.sectors }]} />
      <section className="bg-[#F5F5F3]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-24 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {sectors.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 80}>
              <Link to={p(`secteurs/${s.slug}`)} data-testid={`sector-list-${s.slug}`}
                className="group block h-full bg-white border border-[#101214]/10 rounded-2xl p-8 hover:bg-[#101214] transition-colors duration-300">
                <IconByName name={s.icon} size={26} className="text-[#FF6600]" />
                <h2 className="mt-4 text-lg font-bold text-[#101214] group-hover:text-white transition-colors">{s[lang].title}</h2>
                <p className="mt-3 text-sm text-[#101214]/60 group-hover:text-white/60 leading-relaxed transition-colors">{s[lang].short}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-black text-[#FF6600] uppercase tracking-wider">
                  {lang === "fr" ? "Découvrir" : "Discover"} <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <FinalCTA />
    </div>
  );
};

export default Sectors;
